import { CreateContext, usePickSaveContext, RecordContextProvider, Record, useCreateController } from "ra-core";
import { CreateProps } from "ra-core/esm/controller/details/useCreateController";
import { FC } from "react";
import SaveContextProvider from "./SaveContextProvider";

const Create: FC<CreateProps> = ({ children, ...props }) => {
  const value = useCreateController(props)
  return (
    <CreateContext.Provider value={value}>
      <SaveContextProvider value={usePickSaveContext(value)}>
        <RecordContextProvider<Partial<Record>>
          value={value && value.record}
        >
          {children}
        </RecordContextProvider>
      </SaveContextProvider>
    </CreateContext.Provider>
  )
}

export default Create;
